import IToolConfig from "@/types/IToolConfig";
import { HEADER_SELECTORS,TEXT_SELECTORS } from "@/enum/Selectors";
import { injectToolCSS } from "@/utils/cssGenerator";

export const alignLeftConfig: IToolConfig = {
    id: "align-left",
    selector: `html`,
    childrenSelector: TEXT_SELECTORS,
      styles: {
        'text-align': 'left'
    }
}

export default function alignLeft(enable=false) {
    injectToolCSS({
        ...alignLeftConfig,
        enable
    })
}